import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6.726.75h10.5m-1.5 7.5V.75h-7.5v7.5L1.489 18.615A3 3 0 0 0 4 23.25h15.948a3 3 0 0 0 2.515-4.635zm-10.425 4.5h13.35m-4.425 4.5h3m-1.5-1.5v3m0-15h-3m3 3h-3"
    }, null, -1),
    createElementVNode("path", {
      stroke: "currentColor",
      d: "M6.726 19.875a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75m3-2.25a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75"
    }, null, -1)
  ]));
}
const ecologyScienceErlenmeyerFlask = { render };
export {
  ecologyScienceErlenmeyerFlask as default,
  render
};
//# sourceMappingURL=ecology-science-erlenmeyer-flask.svg.js.map
